import React, { FC } from "react";

interface Props {
  isMobile: boolean;
  label: string;
}

export const SideCtaInnerLabel: FC<Props> = ({ isMobile, label }) =>
  !isMobile ? (
    <span className="text-sm opacity-0 group-hover:opacity-100 transition-all">{label}</span>
  ) : null;
